import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import axios, { AxiosResponse } from 'axios';

export const ListsClientManager = (function () {
  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onGetStaticConfigLists,
    function () {
      _getConfigLists(
        "static",
        LS2PAC_CONSTANTS.Events.onGetStaticConfigListsResponse
      );
    }
  );

  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onGetDynamicConfigLists,
    function () {
      _getConfigLists(
        "dynamic",
        LS2PAC_CONSTANTS.Events.onGetDynamicConfigListsResponse
      );
    }
  );

  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onGetStaticLists,
    function () {
      _getStaticLists();
    }
  );

  var _getConfigLists = function (type, callbackEvent, callback) {
    var success = false,
      lists = [],
      firstResult = 0,
      maxResults = 1000000,
      sortType = "Name";
    //TODO constants rest url

    TLCRest.jsonCall(
      ["lists", type, "config", firstResult, maxResults, sortType].join("/"),
      {
        callback: function (data) {
          success = true;
          lists = data;
        },
        finallyHandler: function () {
          if (callbackEvent !== null) {
            TLCEventManager.fireEvent(callbackEvent, {
              success: success,
              lists: lists,
            });
          }
          if (callback !== undefined) {
            callback(lists);
          }
        },
        timeout: 20000,
        cancellable: true,
        cache: false,
      }
    );
  };

  var _getConfigStaticLists = function (callback) {
    _getConfigLists("static", null, callback);
  };

  var _getStaticLists = function (callback) {
    var success = false,
      lists = [],
      listCount = 0;

    TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.getStaticListCount, {
      callback: function (data) {
        success = true;
        listCount = data.count === 0 ? 1 : data.count;
      },
      finallyHandler: function () {
        if (!success) {
          if (!callback) {
            TLCEventManager.fireEvent(
              LS2PAC_CONSTANTS.Events.onGetStaticListsResponse,
              { success: success, lists: lists }
            );
          } else {
            callback(lists);
          }
        } else {
          success = false;
          TLCRest.jsonCall(
            [
              LS2PAC_CONSTANTS.restUrls.getStaticLists,
              0,
              listCount,
              "Name",
            ].join("/"),
            {
              callback: function (data) {
                success = true;
                lists = data;
                TLCLogger.log("_getStaticLists", lists);
              },
              finallyHandler: function () {
                if (!callback) {
                  TLCEventManager.fireEvent(
                    LS2PAC_CONSTANTS.Events.onGetStaticListsResponse,
                    { success: success, lists: lists }
                  );
                } else {
                  callback(lists);
                }
              },
              timeout: 20000,
              cancellable: true,
              cache: false,
            }
          );
        }
      },
      timeout: 20000,
      cache: false,
    });
  };

  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onRenameList,
    function (event) {
      var success = false;
      var response = {};

      TLCRest.jsonCall(
        [LS2PAC_CONSTANTS.restUrls.renameList, event.listId, event.name].join(
          "/"
        ),
        {
          callback: function (data) {
            success = data.success;
            response = data;
          },
          finallyHandler: function () {
            TLCEventManager.fireEvent(
              LS2PAC_CONSTANTS.Events.onRenameListResponse,
              { success: success, data: response }
            );
          },
          timeout: 20000,
          cancellable: true,
        }
      );
    }
  );

  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onDeleteLists,
    function (event) {
      var response = [];

      TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.deleteLists, {
        postData: {
          listIds: event.listIds,
        },
        callback: function (data) {
          //data is an array of objects
          response = data;
        },
        finallyHandler: function () {
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onDeleteListsResponse,
            { success: true, data: response, listIds: event.listIds }
          );
        },
        timeout: 20000,
        cancellable: true,
      });
    }
  );

  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onAddToList,
    function (event) {
      var url = event.isConfigSearch
        ? LS2PAC_CONSTANTS.restUrls.savePublicStaticList
        : LS2PAC_CONSTANTS.restUrls.savePrivateStaticList;

      var postData = {
        scope: event.isConfigSearch ? "Public" : "Private",
        name: event.name,
        resourceIds: event.resourceIds,
      };

      if (event.listId) {
        url = [LS2PAC_CONSTANTS.restUrls.addToList, event.listId, "add"].join(
          "/"
        );
        postData = event.resourceIds;
      }

      var success = false;
      var response = {};

      TLCRest.jsonCall(url, {
        postData: postData,
        callback: function (data) {
          if (data !== null) {
            response = data;
            success = response.success === undefined ? true : response.success; //TODO have create list return the same status as add to list
          }
        },
        finallyHandler: function () {
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onAddToListResponse,
            { success: success, data: response }
          );
        },
        timeout: 20000,
        cancellable: true,
      });
    }
  );

  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onRemoveItemFromList,
    function (event) {
      var success = false,
        response = {},
        url = [
          LS2PAC_CONSTANTS.restUrls.removeFromList,
          event.listId,
          "remove",
        ].join("/"),
        postData = event.resourceIds;

      TLCRest.jsonCall(url, {
        postData: postData,
        callback: function (data) {
          response = data;
          success = response.success;
          response.count = event.resourceIds.length;
        },
        finallyHandler: function () {
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onRemoveItemFromListResponse,
            { success: success, data: response }
          );
        },
        timeout: 20000,
        cancellable: true,
      });
    }
  );

  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onGetFullListsForBibExport,
    function (event) {
      var listId = event.list.id,
        totalResourceCount = event.list.resourceCount,
        start = 0,
        quantity = 20,
        wholeList = [];

      // totalResourceCount / quantity = total calls

      var combineList = function (subset, success) {
        totalResourceCount = event.list.resourceCount;
        wholeList = wholeList.concat(subset.resources);
        if (wholeList.length < totalResourceCount && success) {
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onGetFullListsForBibExportUpdate,
            {
              success: success,
              data: { total: totalResourceCount, current: wholeList.length },
            }
          );
          getListData(listId, wholeList.length, quantity, combineList);
        } else {
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onGetFullListsForBibExportUpdate,
            {
              success: success,
              data: { total: totalResourceCount, current: wholeList.length },
            }
          );
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onGetFullListsForBibExportResponse,
            { success: success, data: wholeList }
          );
        }
      };
      getListData(listId, start, quantity, combineList);
    }
  );

  var getListData = function (id, start, quantity, callback) {
    var response,
      success = false;
    TLCRest.jsonCall(
      [
        LS2PAC_CONSTANTS.restUrls.getStaticListContent,
        id,
        start,
        quantity,
        "Title",
      ].join("/"),
      {
        callback: function (data) {
          success = true;
          response = data;
        },
        finallyHandler: function () {
          callback(response, success);
        },
      }
    );
  };

  var shareList = function ({listId, friends, note}) {
    let success = false;

    axios.post(`list/static/${listId}/email`, {friends, note})
    .then(() => {
      success = true;
    }).finally(() => {
      const message = success === true ? ApplicationData.language.sharedListSuccessMessage : ApplicationData.language.sharedListErrorMessage;
      TLCEventManager.fireEvent(
        LS2PAC_CONSTANTS.Events.onShareThisResponse,
        { success: success, message: message }
      );
    });
  };

  TLCEventManager.addListener(
    LS2PAC_CONSTANTS.Events.onShareThis,
    function (event) {
      if (event.shareType == LS2PAC_CONSTANTS.shareTypes.staticList) {
        shareList(event);
      }
    }
  );

  return {
    getStaticLists: function (callback) {
      _getStaticLists(callback);
    },
    getConfigStaticLists: function (callback) {
      _getConfigStaticLists(callback);
    },
  };
})();
